interface Props {
  name: string;
  onNameChange: (name: string) => void;
  step: "body" | "fields" | "preview";
  onStepChange: (step: "body" | "fields" | "preview") => void;
  bodyDisabled?: boolean;
  bodyDisabledReason?: string;
  fieldsDisabled?: boolean;
  fieldsDisabledReason?: string;
  previewDisabled?: boolean;
  previewDisabledReason?: string;
  onSave: () => void;
  onCancel: () => void;
  isDirty: boolean;
  saveLabel?: string;
  isSaving?: boolean;
  readOnly?: boolean;
  readOnlyReason?: string;
}

export const ContractEditorToolbar = ({
  name,
  onNameChange,
  step,
  onStepChange,
  bodyDisabled = false,
  bodyDisabledReason,
  fieldsDisabled = false,
  fieldsDisabledReason,
  previewDisabled = false,
  previewDisabledReason,
  onSave,
  onCancel: _onCancel,
  isDirty,
  saveLabel = "저장",
  isSaving = false,
  readOnly = false,
  readOnlyReason,
}: Props) => {
  const stepButtonClass = (active: boolean, disabled = false) =>
    `text-[12px] font-semibold rounded-full px-3 py-1.5 border ${
      active
        ? "bg-[#FF9934] text-white border-[#FF9934]"
        : disabled
          ? "bg-[#F5F5F5] text-[#BDBDBD] border-[#E9E9E9] cursor-not-allowed"
          : "bg-white text-[#666] border-[#E9E9E9]"
    }`;

  return (
    <div className="bg-white border-b border-[#E9E9E9] sticky top-0 z-10">
      <div className="px-4 py-3">
        <label className="block text-[11px] font-semibold text-[#777] mb-1">
          양식 이름
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          disabled={readOnly}
          placeholder="예: 위탁 계약서 v3"
          title={readOnly ? readOnlyReason : undefined}
          className="w-full rounded-xl border border-[#E1E1E1] bg-[#FAFAFA] px-3 py-2.5 text-[16px] font-bold text-[#111] outline-none placeholder-[#BDBDBD] focus:border-[#FF9934] focus:bg-white disabled:bg-[#F5F5F5] disabled:text-[#999]"
        />
      </div>
      <div className="flex items-center gap-2 px-4 pb-3">
        <button
          type="button"
          onClick={() => onStepChange("body")}
          aria-disabled={bodyDisabled}
          title={bodyDisabled ? bodyDisabledReason : undefined}
          className={stepButtonClass(step === "body", bodyDisabled)}
        >
          1. 본문 작성
        </button>
        <button
          type="button"
          onClick={() => onStepChange("fields")}
          aria-disabled={fieldsDisabled}
          title={fieldsDisabled ? fieldsDisabledReason : undefined}
          className={stepButtonClass(step === "fields", fieldsDisabled)}
        >
          2. 필드 설정
        </button>
        <button
          type="button"
          onClick={() => onStepChange("preview")}
          aria-disabled={previewDisabled}
          title={previewDisabled ? previewDisabledReason : undefined}
          className={stepButtonClass(step === "preview", previewDisabled)}
        >
          3. 검토
        </button>
        <div className="flex-1" />
        {isDirty && (
          <span className="text-[10px] text-[#FF9934] font-semibold">
            ● 저장하지 않음
          </span>
        )}
        <button
          type="button"
          onClick={onSave}
          disabled={!name.trim() || readOnly || isSaving}
          title={readOnly ? readOnlyReason : undefined}
          className="text-[13px] font-bold bg-[#FF9934] text-white rounded-full px-4 py-1.5 disabled:bg-[#E9E9E9] disabled:text-[#999]"
        >
          {isSaving ? "처리 중..." : saveLabel}
        </button>
      </div>
      <div className="text-[10px] text-[#999] px-4 pb-2">
        활성/비활성 변경은 양식 목록 화면에서 할 수 있어요
      </div>
    </div>
  );
};
